import React from "react";
import Footer from "./Footer";

const Frame = ({ children, dotnav = null }) => (
  <div className="frame">
    {dotnav}
    <main>{children}</main>
    <Footer />
  </div>
);

export default Frame;
